import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "editor-layout"
};
const _hoisted_2 = {
  key: 0,
  class: "editor-data-loading"
};
const _hoisted_3 = {
  key: 1,
  class: "editor-load-error"
};
const _hoisted_4 = {
  class: "err-msg"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_spin = _resolveComponent("a-spin");
  const _component_CloseOutlined = _resolveComponent("CloseOutlined");
  const _component_a_form = _resolveComponent("a-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_a_spin, {
    size: "large"
  }), _cache[0] || (_cache[0] = _createElementVNode("span", null, "数据加载中...", -1))])) : _createCommentVNode("", true), $props.error ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_CloseOutlined), _createElementVNode("span", _hoisted_4, _toDisplayString($props.error), 1)])) : _createCommentVNode("", true), !$props.loading ? (_openBlock(), _createBlock(_component_a_form, _mergeProps({
    key: 2,
    ref: "formRef",
    model: $props.model,
    rules: $props.rules
  }, _ctx.$attrs, {
    colon: "",
    "label-align": "right",
    "label-col": $setup.labelStyle
  }), {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, undefined, true)]),
    _: 3
  }, 16, ["model", "rules", "label-col"])) : _createCommentVNode("", true)]);
}